export default __webpack_public_path__ + "static/home-background-lg-31fc21616e3fa8f8339569fd41ca42a7.jpg";